import { styled } from '@mui/material'
import { Button } from '../../../../components/buttons'
import { intl } from '../../../../../i18n'
import { useMemo } from 'react'

const SubmitButton = ({
  onClick,
  disabled,
}: {
  onClick: () => void
  disabled?: boolean
}) => {
  const label = useMemo(() => intl.formatMessage({ id: 'submit' }), [])
  return (
    <StyledButton
      variant="filled"
      colorPattern="skyBlue"
      size="s"
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </StyledButton>
  )
}

export default SubmitButton

// Style
const StyledButton = styled(Button)({
  width: '100px',
})
